export const numberEmployeesList = [
  {
    title: 'Select number of employees',
    value: '',
    default: true,
    hidden: true,
    disabled: true,
  },
  {
    title: '1-10',
    value: '1-10',
    default: false,
    hidden: false,
    disabled: false,
  },
  {
    title: '11-50',
    value: '11-50',
    default: false,
    hidden: false,
    disabled: false,
  },
  {
    title: '51-200',
    value: '51-200',
    default: false,
    hidden: false,
    disabled: false,
  },
  {
    title: '201-500',
    value: '201-500',
    default: false,
    hidden: false,
    disabled: false,
  },
  {
    title: '501-1,000',
    value: '501-1,000',
    default: false,
    hidden: false,
    disabled: false,
  },
  {
    title: '1,001-5,000',
    value: '1,001-5,000',
    default: false,
    hidden: false,
    disabled: false,
  },
  {
    title: '5,001-10,000',
    value: '5,001-10,000',
    default: false,
    hidden: false,
    disabled: false,
  },
  {
    title: '10000+',
    value: '10000+',
    default: false,
    hidden: false,
    disabled: false,
  },
];
